import { render } from "./EclipseTimer.vue?vue&type=template&id=efdf7b04&ts=true"
import script from "./EclipseTimer.vue?vue&type=script&lang=ts"
export * from "./EclipseTimer.vue?vue&type=script&lang=ts"

import "./EclipseTimer.vue?vue&type=style&index=0&id=efdf7b04&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__